<p style="margin: 16px 0px;padding: 0px 100px;">Please wait until the file scanning process completes...</p>
